import { Region } from "feiertagejs";

export const STORAGE_KEY_PICKED_RANGE = "rental-overview-picked-daterange";
export const regionsForHolidays: Region[] = ["BW"];
